<template>
  <div>
    <el-dialog
      title="表单提交"
      :visible.sync="dialogVisible"
      width="45%"
      :before-close="handleClose"
    >
      <div class="dialog-body">
        <el-form
          :model="form"
          :rules="rules"
          ref="form"
          label-width="160px"
          class="ccui-form"
        >
          <el-form-item label="单位全称：" prop="reqname">
            <el-input
              v-model="form.reqname"
              class="ccui-form-shortInput"
              placeholder="请输入单位全称"
              clearable
              maxlength="50"
            />
          </el-form-item>
          <el-form-item label="邮箱：" prop="reqemail">
            <el-input
              v-model="form.reqemail"
              class="ccui-form-shortInput"
              placeholder="请输入邮箱"
              clearable
              maxlength="50"
            />
          </el-form-item>
          <el-form-item label="类型：" prop="type">
            <el-select
              v-model="form.type"
              clearable
              placeholder="请选择类型"
              class="ccui-form-shortInput"
            >
              <el-option key="分包商" label="分包商" value="0"></el-option>
              <el-option key="供应商" label="供应商" value="1"></el-option>
              <el-option key="商家" label="商家" value="2"></el-option>
              <el-option key="采购单位" label="采购单位" value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="手机号码：" prop="reqmobile">
            <div
              style="
                display: flex;
                width: 300px;
                /* align-items: self-end; */
                justify-content: space-between;
              "
            >
              <el-input
                style="margin-right: 5px"
                v-model="form.reqmobile"
                placeholder="请输入手机号码"
                clearable
                maxlength="11"
              />
              <el-button @click="sendCode" :disabled="isSend"
                ><span v-if="isSend">{{ countDown }}秒后</span
                >发送验证码</el-button
              >
            </div>
          </el-form-item>
          <el-form-item label="验证码：" prop="smsCode">
            <el-input
              v-model="form.smsCode"
              class="ccui-form-shortInput"
              placeholder="请输入验证码"
              clearable
              maxlength="50"
            />
          </el-form-item>
          <el-form-item label="附件模板：">
            <a
              class="donload-font"
              download="交建云商密码找回模板"
              href="https://cccc-prod.obs.cn-north-4.myhuaweicloud.com/cccc_temp/temp25582ca272664fd99c05de84382dbe5b.doc"
              >点击此处下载</a
            >附件模板（按照模板填写之后上传）
          </el-form-item>

          <el-form-item label="附件上传：">
            <el-upload
              :show-file-list="false"
              :action="url"
              style="display: inline-block"
              :before-upload="beforeAvatarUpload"
              :on-success="onSuccess"
              :on-progress="onProgress"
              :on-error="onError"
            >
              <!-- :data="fromData" -->
              <div slot="tip" class="el-upload__tip">
                只能上传doc/docx/pdf文件，且不超过50M
              </div>
              <el-button plain type="single-number"> 点击上传 </el-button>
            </el-upload>
          </el-form-item>
          <el-form-item label="">
            <div class="file-list" :title="fileList[0].fileName">
              {{ fileList[0].fileName }}
            </div>
          </el-form-item>
        </el-form>
        <div class="nocaptcha-wp" v-if="isnocaptcha">
          <NoCaptcha
            ref="NoCaptcha"
            class="nocaptcha"
            @successAWSC="successAWSC"
          />
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="submit" :disabled="showBtn"
          >提 交</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { add, send } from "../api/submit";
import NoCaptcha from "./NoCaptcha.vue";
import { addUrlPerFix } from "@/basa/utils";

export default {
  components: { NoCaptcha },
  props: {},
  data() {
    let checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("手机号不能为空"));
      } else {
        const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error("请输入正确的手机号"));
        }
      }
    };
    return {
      code: "",
      countDown: 60,
      isSend: false,
      showBtn: true,
      dialogVisible: false,
      isnocaptcha: false,
      form: {
        reqname: "",
        reqemail: "",
        reqmobile: "",
        type: "",
        fileurl: "",
        smsCode: "",
      },
      fromData: { openId: "", userName: "" },
      rules: {
        reqname: [
          { required: true, message: "请输入单位全称", trigger: "blur" },
        ],
        reqemail: [
          { required: true, message: "请输入邮箱地址", trigger: "blur" },
          { type: "email", message: "请输入正确的邮箱地址", trigger: "blur" },
        ],
        reqmobile: [
          {
            required: true,
            validator: checkPhone,
            trigger: ["blur", "change"],
          },
        ],
        type: [
          {
            required: true,
            message: "请选择类型",
            trigger: ["blur", "change"],
          },
        ],
      },
      fileList: [
        {
          fileName: "",
        },
      ],
      url: `${addUrlPerFix(
        process.env.VUE_APP_BASA_URL
      )}/apis/basap/users/signup/uploadLogo`,
    };
  },
  methods: {
    sendCode() {
      if (!this.form.reqmobile) {
        this.$message.warning("手机号不能为空！");
        return;
      }
      this.isnocaptcha = true;
    },
    successAWSC(obj) {
      this.isnocaptcha = false;
      this.showBtn = obj.disabledBtn;
      this.code = obj.code;

      send({
        reqmobile: this.form.reqmobile,
        sessionId: obj.code,
        agentId: 100003,
      }).then((res) => {
        if (res.data.code == "0" && res.data.message == "成功") {
          let timer = setInterval(() => {
            if (this.countDown > 0) {
              this.countDown--;
              this.isSend = true;
            } else {
              clearInterval(timer);
              this.isSend = false; // 启用按钮
              this.countDown = 60; // 重置倒计时时间
            }
          }, 1000);
        }
      });
    },
    handleClose(done) {
      this.$refs.form.resetFields();
      // this.$refs.NoCaptcha.reset();
      this.fileList = [{ fileName: "" }];
      this.showBtn = true;
      this.dialogVisible = false;
      this.isnocaptcha = false;
    },
    beforeAvatarUpload(file) {
      if (this.fileList.length > 1) {
        this.$message.warning("单次只能上传一个附件");
        return;
      }
      const isLt50 = file.size < 52428800;
      var testmsg = file.name.substring(file.name.lastIndexOf("."));
      let fileType = [
        ".doc",
        ".docx",
        ".DOC",
        ".DOCX",
        ".pdf",
        ".PDF",
      ].includes(testmsg);
      if (!isLt50) {
        // "文件大小不超过50M!"
        this.$message({
          showClose: true,
          message: "文件大小不超过50M!",
          type: "error",
          duration: 0,
        });
      }
      if (file.size === 0) {
        // "文件大小不可为0B!"
        this.$message({
          showClose: true,
          message: "文件大小不可为0B!",
          type: "error",
          duration: 0,
        });
      }
      if (!fileType) {
        // "上传文件格式错误！"
        this.$message({
          showClose: true,
          message: "上传文件格式错误！",
          type: "error",
          duration: 0,
        });
      }
      return isLt50 && fileType && file.size > 0;
    },
    onProgress(res) {
      this.uploadLoading = this.$loading({
        lock: true,
        text: "上传中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
    },
    onSuccess(res) {
      let fileData = res.data[0];
      this.$set(this.fileList, 0, {
        fileName: fileData.fileName,
      });
      this.form.fileurl = fileData.downloadUrl;
      this.$message.success("上传成功!");
      this.uploadLoading.close();
    },
    onError() {
      // "上传至服务器失败请重新上传"
      this.$message.error("上传至服务器失败请重新上传");
      this.uploadLoading.close();
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (!this.form.fileurl) {
            this.$message.error("请上传附件！");
            return;
          }
          this.$confirm(
            "请再次确认手机号码，审批通过后手机号码会绑定为当前填写号码",
            "",
            {
              iconClass: "el-icon-info",
            }
          )
            .then((_) => {
              add({
                ...this.form,
                agentId: 100001,
                sessionId: this.code,
              }).then((res) => {
                this.$message.success(res.data.message);
                this.handleClose();
              });
            })
            .catch((_) => {
              this.handleClose();
            });
        } else {
          // this.$refs.NoCaptcha.reset();
          this.isnocaptcha = false;
          this.showBtn = true;
          return false;
        }
      });
    },
  },
  filter: {},
  computed: {},
  watch: {},
};
</script>

<style lang="scss" scoped>
.ccui-form .ccui-form-shortInput {
  width: 300px;
}
.file-list {
  width: 300px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: default;
}
.donload-font {
  color: #0089ef;
  text-decoration: underline;
}
.el-dialog__body .el-form /deep/.el-form-item {
  margin-bottom: 27px !important;
}
.dialog-body {
  position: relative;
  .nocaptcha-wp {
    top: 0;
    background: #0000006f;
    width: 100%;
    height: 100%;
    position: absolute;
    .nocaptcha {
      margin: 30% auto;
      width: 300px !important;
    }
  }
}
</style>
